export interface Category {
  id: string;
  name: string;
  namePt: string;
  url: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Tênis',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Os tênis mais desejados do momento',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    namePt: 'Moletons',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Moletons e suéteres premium',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'Camisetas',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Camisetas streetwear exclusivas',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jaquetas',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Jaquetas e casacos estilosos',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    namePt: 'Calças/Bermudas',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Calças e bermudas da moda',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Acessórios de Cabeça',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Bonés e gorros estilosos',
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Conjuntos',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Conjuntos completos coordenados',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    namePt: 'Roupas Íntimas',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Roupas íntimas de qualidade',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Camisas Esportivas',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Camisas de times e esportivas',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Acessórios',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Acessórios essenciais de moda',
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bolsas',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Bolsas e mochilas premium',
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Cintos',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Cintos de couro e acessórios',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragrâncias importadas exclusivas',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Outros Itens',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Itens diversos e achados especiais',
  },
];